<template>
  <div>
    <div class="slots">
      <div class="row no-gutters">
        <TimeSlot v-for="group in displayedSlotGroups" :s="group" :key="group.label" @choose="$emit('choose', $event)" />
      </div>
    </div>
    <a href="#" class="btn btn-link mt-2" v-if="displayShowMore" @click.prevent="showMore">
      <i class="fa fa-caret-down mr-1" />
      More
    </a>
  </div>
</template>

<script charset="utf-8">
import TimeSlot from "./TimeSlot.vue";
import _ from "underscore";

export default {
  name: "DaySlots",
  props: ["slots"],
  components: { TimeSlot },

  data() {
    return {
      showAll: false,
      foldedItemCount: 6,
    };
  },

  computed: {
    displayShowMore: function() {
      return this.allSlotGroups.length > this.displayedSlotGroups.length;
    },

    allSlotGroups: function() {
      var grouped = _.groupBy(this.slots, function(s) {
        return s.label;
      });
      var sorted = _.sortBy(_.pairs(grouped), function(v) {
        return v.ts;
      });
      return _.map(sorted, function(g) {
        var slots = g[1];
        return { label: slots[0].label, count: slots.length, slots: slots };
      });
    },

    displayedSlotGroups: function() {
      if (this.showAll) {
        return this.allSlotGroups;
      } else {
        return _.first(this.allSlotGroups, this.foldedItemCount);
      }
    },
  },

  methods: {
    showMore() {
      this.showAll = true;
    },
  },
};
</script>
